// src/pages/Insights/Articles/ArticleData.ts
// Re-exporting all posts with proper typing

import allPosts from './posts/ArticlePosts';
import { Article } from '../types';

export {
  allPosts
};

// Also export a typed version if needed for specific use cases
export const typedAllPosts: Article[] = allPosts;